import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { NamedId } from 'src/app/services/marketing-campaigns/marketing-campaigns-group/marketing-campaign-groups-ids-form';

@Component({
  selector: 'app-item-selection',
  templateUrl: './item-selection.component.html',
  styleUrls: ['./item-selection.component.scss']
})
export class ItemSelectionComponent {
  @Input() items: NamedId[] = [];
  @Input() form!: FormGroup;
  @Input() selectedIds!: Set<string>;
  @Input() selectAllState!: FormControl<boolean | null>;
  @Input() label = 'items';
  @Output() selectionChanged = new EventEmitter<Set<string>>();
  @Output() toggleSelectAll = new EventEmitter<void>();

  get itemsFormArray(): FormArray {
    return this.form.get('items') as FormArray;
  }

  onToggleSelectAll(): void {
    this.toggleSelectAll.emit();
  }

  trackByItemId(index: number, item: NamedId): string {
    return item.id;
  }
}
